import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AssignRolesDto,
  ChangeUserPasswordDto,
  ChangeUserStatusDto,
  CreateUserDto,
  UpdateUserDto,
  UserDetailsDto,
  UserDto,
  UserPaginationParams,
  UserRoleInfoDto
} from 'app/models/user';
import { PaginatedResult } from 'app/models/business-setting';
import { ApiResponse } from 'app/models/api-response';

@Injectable({
  providedIn: 'root'
})
export class CustomUserService {

  // ✅ FIX: ضفنا /customusers في الآخر
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + '/api/admin/customusers';
  }

  constructor(private http: HttpClient) { }

  // ============================================================
  // Users CRUD
  // ============================================================

  // GET: api/admin/customusers
  getAll(params: UserPaginationParams = {}): Observable<ApiResponse<PaginatedResult<UserDto>>> {
    return this.http.get<ApiResponse<PaginatedResult<UserDto>>>(
      this.apiUrl,
      { params: this.buildParams(params) }
    );
  }

  // GET: api/admin/customusers/{id}
  getById(id: number): Observable<ApiResponse<UserDetailsDto>> {
    return this.http.get<ApiResponse<UserDetailsDto>>(`${this.apiUrl}/${id}`);
  }

  // POST: api/admin/customusers
  create(dto: CreateUserDto): Observable<ApiResponse<{ id: number }>> {
    return this.http.post<ApiResponse<{ id: number }>>(this.apiUrl, dto);
  }

  // PUT: api/admin/customusers/{id}
  update(id: number, dto: UpdateUserDto): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/${id}`, dto);
  }

  // DELETE: api/admin/customusers/{id}
  delete(id: number): Observable<ApiResponse<any>> {
    return this.http.delete<ApiResponse<any>>(`${this.apiUrl}/${id}`);
  }

  // ============================================================
  // Status & Password
  // ============================================================

  // PATCH: api/admin/customusers/{id}/status
  changeStatus(id: number, dto: ChangeUserStatusDto): Observable<ApiResponse<any>> {
    return this.http.patch<ApiResponse<any>>(`${this.apiUrl}/${id}/status`, dto);
  }

  // PUT: api/admin/customusers/{id}/password
  changePassword(id: number, dto: ChangeUserPasswordDto): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/${id}/password`, dto);
  }

  // ============================================================
  // Roles
  // ============================================================

  // GET: api/admin/customusers/{id}/roles
  getUserRoles(id: number): Observable<ApiResponse<UserRoleInfoDto[]>> {
    return this.http.get<ApiResponse<UserRoleInfoDto[]>>(`${this.apiUrl}/${id}/roles`);
  }

  // POST: api/admin/customusers/{id}/roles (استبدال كامل)
  assignRoles(id: number, dto: AssignRolesDto): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/${id}/roles`, dto);
  }

  // POST: api/admin/customusers/{id}/roles/{roleId}
  addRole(id: number, roleId: number): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/${id}/roles/${roleId}`, {});
  }

  // DELETE: api/admin/customusers/{id}/roles/{roleId}
  removeRole(id: number, roleId: number): Observable<ApiResponse<any>> {
    return this.http.delete<ApiResponse<any>>(`${this.apiUrl}/${id}/roles/${roleId}`);
  }

  // ============================================================
  // Meta
  // ============================================================

  // GET: api/admin/customusers/user-types
  getUserTypes(): Observable<ApiResponse<string[]>> {
    return this.http.get<ApiResponse<string[]>>(`${this.apiUrl}/user-types`);
  }

  // ============================================================
  // Helper
  // ============================================================

  private buildParams(params: UserPaginationParams): HttpParams {
    let httpParams = new HttpParams();

    if (params.pageNumber) httpParams = httpParams.set('pageNumber', params.pageNumber.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    if (params.search && params.search.trim()) httpParams = httpParams.set('search', params.search.trim());
    if (params.userType) httpParams = httpParams.set('userType', params.userType);
    if (params.status !== undefined && params.status !== null)
      httpParams = httpParams.set('status', params.status.toString());
    if (params.banned !== undefined && params.banned !== null)
      httpParams = httpParams.set('banned', params.banned.toString());

    return httpParams;
  }
}